import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class Header extends Component {
  state = {};
  render() {
    return (
      <header>
        <div className="container">
          <div className="full-h row justify-content-center">
            <div className="col-lg-10 align-self-center">
              <h1 className="main-title">PaupeR</h1>
              <div className="row my-4">
                <div className="col-8">
                  <p className="lead">
                    PaupeR é um banco de dados sobre a pobreza na Alta Idade
                    Média. Nele estão compiladas as ocorrências de palavras
                    latinas que correspondem ao campo semântico do pobre e da
                    pobreza, bem como suas informações correlatas em diversos
                    documentos datados dos séculos VI a IX.
                  </p>
                  <p className="lead">
                    Este projeto foi financiado pela FAPESP, no. de processo
                    2018/11355-8.
                  </p>
                </div>
                <div className="col-4">
                  <p className="description">
                    Este banco de dados foi elaborado por Thiago Juarez Ribeiro
                    da Silva.
                  </p>
                  <p>
                    Lattes:{' '}
                    <a
                      href="http://lattes.cnpq.br/0228693460351030"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      http://lattes.cnpq.br/0228693460351030
                    </a>
                  </p>
                </div>
              </div>
              <Link to="/data">
                <button className="btn btn-primary">
                  Visualizar dados{' '}
                  <i className="fas fa-long-arrow-alt-right"></i>
                </button>
              </Link>
              <a
                href="https://github.com/thirisi/Projeto-PaupeR"
                target="_blank"
                rel="noopener noreferrer"
              >
                <button className="btn btn-transparent">
                  GitHub <i className="fab fa-github"></i>
                </button>
              </a>
              <p className="creditos">
                Desenvolvimento web por{' '}
                <b>
                  <a
                    href="http://viniciusofp.com.br"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    viniciusofp
                  </a>
                  .
                </b>
              </p>
            </div>
          </div>
        </div>
      </header>
    );
  }
}

export default Header;
